export default __webpack_public_path__ + "static/media/T165_RoHS.9ed3943c.pdf";